// constants
import { UserRole } from "../../constants/userRole";
import { UsersActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  sellerList: [],
  agentList: [],
  deliveryList: [],
  one: null,
  loading: false,
  downloadLoading: false,
};

interface UserCreate {
  name: string;
  role: UserRole;
  email: string;
  password: string;
  phone: string;
}

interface UsersData {
  items?: any[];
  total?: number;
}

interface GetUsersData {
  id: string;
}

interface UsersActionType {
  type:
    | UsersActionTypes.GET_LIST_USERS
    | UsersActionTypes.GET_LIST_USERS_ERROR
    | UsersActionTypes.GET_LIST_USERS_SUCCESS
    | UsersActionTypes.CREATE_USER
    | UsersActionTypes.CREATE_USER_SUCCESS
    | UsersActionTypes.CREATE_USER_ERROR
    | UsersActionTypes.GET_USER
    | UsersActionTypes.GET_USER_SUCCESS
    | UsersActionTypes.GET_USER_ERROR
    | UsersActionTypes.UPDATE_USER
    | UsersActionTypes.UPDATE_USER_SUCCESS
    | UsersActionTypes.UPDATE_USER_ERROR
    | UsersActionTypes.UPDATE_USER_PASSWORD
    | UsersActionTypes.UPDATE_USER_PASSWORD_SUCCESS
    | UsersActionTypes.UPDATE_USER_PASSWORD_ERROR
    | UsersActionTypes.UPDATE_USER_ACTIVATION
    | UsersActionTypes.UPDATE_USER_ACTIVATION_SUCCESS
    | UsersActionTypes.UPDATE_USER_ACTIVATION_ERROR
    | UsersActionTypes.DELETE_USER
    | UsersActionTypes.DELETE_USER_SUCCESS
    | UsersActionTypes.DELETE_USER_ERROR
    | UsersActionTypes.DOWNLOAD_USERS
    | UsersActionTypes.DOWNLOAD_USERS_SUCCESS
    | UsersActionTypes.DOWNLOAD_USERS_ERROR
    | UsersActionTypes.UPDATE_USER_PROFILE
    | UsersActionTypes.UPDATE_USER_PROFILE_SUCCESS
    | UsersActionTypes.UPDATE_USER_PROFILE_ERROR
    | UsersActionTypes.GET_SELLER_LIST
    | UsersActionTypes.GET_SELLER_LIST_SUCCESS
    | UsersActionTypes.GET_SELLER_LIST_ERROR
    | UsersActionTypes.GET_AGENT_LIST
    | UsersActionTypes.GET_AGENT_LIST_SUCCESS
    | UsersActionTypes.GET_AGENT_LIST_ERROR
    | UsersActionTypes.GET_DELIVERY_LIST
    | UsersActionTypes.GET_DELIVERY_LIST_SUCCESS
    | UsersActionTypes.GET_DELIVERY_LIST_ERROR;
  payload: {
    actionType?: string;
    data?: UsersData;
    createData?: UserCreate;
    getUser?: GetUsersData;
    error?: string;
    userCreateError?: string;
    updated: false;
    passwordUpdated: false;
    refreshList: false;
    downloadLoading: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Users = (state: State = INIT_STATE, action: UsersActionType): any => {
  switch (action.type) {
    case UsersActionTypes.GET_SELLER_LIST:
      return {
        ...state,
        loading: true,
      };

    case UsersActionTypes.GET_SELLER_LIST_SUCCESS:
      return {
        ...state,
        sellerList: action.payload.data.items,
        loading: false,
        error: "",
      };

    case UsersActionTypes.GET_SELLER_LIST_ERROR:
      return {
        ...state,
        error: action.payload.error,
        sellerList: [],
        loading: false,
      };

    case UsersActionTypes.GET_AGENT_LIST:
      return {
        ...state,
        loading: true,
      };

    case UsersActionTypes.GET_AGENT_LIST_SUCCESS:
      return {
        ...state,
        agentList: action.payload.data.items,
        loading: false,
        error: "",
      };

    case UsersActionTypes.GET_AGENT_LIST_ERROR:
      return {
        ...state,
        error: action.payload.error,
        agentList: [],
        loading: false,
      };

    case UsersActionTypes.GET_DELIVERY_LIST:
      return {
        ...state,
        loading: true,
      };

    case UsersActionTypes.GET_DELIVERY_LIST_SUCCESS:
      return {
        ...state,
        deliveryList: action.payload.data.items,
        loading: false,
        error: "",
      };

    case UsersActionTypes.GET_DELIVERY_LIST_ERROR:
      return {
        ...state,
        error: action.payload.error,
        deliveryList: [],
        loading: false,
      };

    case UsersActionTypes.GET_USER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        userCreateError: "",
        total: 0,
        updated: false,
        passwordUpdated: false,
      };
    case UsersActionTypes.GET_USER_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.GET_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            userCreateError: "",
            updated: false,
            passwordUpdated: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.GET_USER_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.GET_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            userCreateError: action.payload.error,
            updated: false,
            passwordUpdated: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_PROFILE:
      return {
        ...state,
        loading: true,
        error: "",
        profileUpdated: false,
      };

    case UsersActionTypes.UPDATE_USER_PROFILE_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_PROFILE: {
          return {
            ...state,
            loading: false,
            one: action.payload.data,
            error: "",
            profileUpdated: true,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_PROFILE_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_PROFILE: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
            profileUpdated: false,
          };
        }
        default:
          return { ...state };
      }
    case UsersActionTypes.CREATE_USER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        userCreateError: "",
        total: 0,
      };
    case UsersActionTypes.CREATE_USER_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.CREATE_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            userCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.CREATE_USER_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.CREATE_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            userCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        userCreateError: "",
        total: 0,
      };

    case UsersActionTypes.UPDATE_USER_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            userCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            userCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.GET_LIST_USERS_SUCCESS:
      switch (action.payload?.actionType) {
        case UsersActionTypes.GET_LIST_USERS: {
          const data = action.payload.data;
          const list = Array.isArray(data?.items) ? data.items : [];
          const total = typeof data?.total === "number" ? data.total : 0;
          return {
            ...state,
            list,
            total,
            loading: false,
            one: null,
            error: "",
            userCreateError: "",
            updated: false,
            passwordUpdated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.GET_LIST_USERS_ERROR:
      switch (action.payload?.actionType) {
        case UsersActionTypes.GET_LIST_USERS:
          return {
            ...state,
            error: action.payload.error,
            list: [],
            total: 0,
            loading: false,
            updated: false,
            passwordUpdated: false,
            refreshList: false,
          };
        default:
          return { ...state };
      }

    case UsersActionTypes.GET_LIST_USERS:
      return {
        ...state,
        loading: true,
        list: [],
        total: 0,
        one: null,
        error: "",
        userCreateError: "",
        updated: false,
        passwordUpdated: false,
        refreshList: false,
      };

    case UsersActionTypes.UPDATE_USER_PASSWORD:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        userCreateError: "",
        total: 0,
      };

    case UsersActionTypes.UPDATE_USER_PASSWORD_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_PASSWORD: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            userCreateError: "",
            passwordUpdated: true,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_PASSWORD_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_PASSWORD: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            userCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_ACTIVATION:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        userCreateError: "",
        refreshList: false,
        total: 0,
      };

    case UsersActionTypes.UPDATE_USER_ACTIVATION_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_ACTIVATION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            userCreateError: "",
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.UPDATE_USER_ACTIVATION_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.UPDATE_USER_ACTIVATION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            userCreateError: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.DELETE_USER:
      return {
        ...state,
        refreshList: false,
      };

    case UsersActionTypes.DELETE_USER_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.DELETE_USER: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.DELETE_USER_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.DELETE_USER: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.DOWNLOAD_USERS:
      return {
        ...state,
        refreshList: false,
        downloadLoading: true,
      };

    case UsersActionTypes.DOWNLOAD_USERS_SUCCESS:
      switch (action.payload.actionType) {
        case UsersActionTypes.DOWNLOAD_USERS: {
          return {
            ...state,
            refreshList: false,
            downloadLoading: false,
          };
        }
        default:
          return { ...state };
      }

    case UsersActionTypes.DOWNLOAD_USERS_ERROR:
      switch (action.payload.actionType) {
        case UsersActionTypes.DOWNLOAD_USERS: {
          return {
            ...state,
            error: action.payload.error,
            downloadLoading: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Users;
